export const TEMPLATES_PER_PAGE = 15;
export const RECENT_TEMPLATES_COUNT = 3;
